
        import Symbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-rescls-style_3d",
  "use": "icon-rescls-style_3d-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-rescls-style_3d\"><path fill=\"#00b066\" d=\"M7.858 14.452C2.702 14.934 4.89 19.833 2 21.278c3.749.722 7.733-1.044 7.889-4.738-.079-.16-2.031-2.088-2.031-2.088\" /><path fill=\"#aec8e0\" d=\"M10.356 15.979 8.404 13.97c.625-2.168 2.811-4.336 5.936-6.744 3.28-2.49 6.716-5.14 6.716-5.14s.391-.241.781.08c.313.4.078.803.078.803s-2.655 3.614-4.999 6.905c-2.342 3.212-4.451 5.461-6.56 6.104\" /><path fill=\"#dce8f3\" d=\"m16.375 9.662-5.625 2.644 5.625 2.643L22 12.306z\" /><path fill=\"#3498db\" d=\"M16.375 22 22 19.356v-7.05l-5.625 2.643z\" /><path fill=\"#81b0dc\" d=\"m16.375 22-5.625-2.644v-7.05l5.625 2.643z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-rescls-style_3d"/>
                </svg>
            );
        };

        Icon.id = "icon-rescls-style_3d";

        export default Icon;
    